export default "__VITE_ASSET__E1oT5XVqd9fm5KE3Ey4O5A__"